/**
 * Ryan O'Dowd
 * 2025-06-08
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  TouchableOpacity,
  View,
} from 'react-native';
import {
  Checkbox as PaperCheckbox,
} from 'react-native-paper';
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const Checkbox = (props: CheckboxProps & Omit<React.ComponentProps<typeof PaperCheckbox>, 'status'>) => {
  const styles = hooks.useStyles(getStyles);

  let status: 'checked' | 'unchecked' | 'indeterminate' = 'unchecked';
  if (props.isChecked) {
    status = 'checked';
  } else if (props.isChecked !== false) {
    status = 'indeterminate';
  }

  let uncheckedColor = styles.isDarkMode ? styles.colors.white : styles.colors.primaryDark;
  if (props.color === styles.colors.accent) {
    uncheckedColor = styles.colors.primaryExtraLight;
  }

  return (
    <View style={styles.container}>
      <PaperCheckbox.Android
        uncheckedColor={uncheckedColor}
        {...props}
        status={status}
      />
      <TouchableOpacity
        onPress={props.onPress}
        disabled={props.disabled}
      >
        <Text style={[styles.label(props.labelColor || uncheckedColor), props.labelStyles]}>{props.label}</Text>{/* @TODO: this should be pressable as well */}
      </TouchableOpacity>
    </View>
  );
};

class CheckboxProps {
  isChecked?: boolean; // @NOTE: status is disallowed (should be passing optional isChecked instead)
  label?: string;
  labelColor?: string;
  labelStyles?: {};
};

Checkbox.displayName = 'Checkbox';
export default Checkbox;
